/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 已投稿库Js
 */
'use strict';
angular.module('submissionLibraryModule', []).controller('submissionLibraryCtrl', [
    '$scope',
    '$filter',
    'httpService',
    '$sce',
    function ($scope, $filter, httpService, $sce) {
        initStatus();
        initData();
        /**
         * [initStatus description] 初始化参数
         */
        function initStatus() {
            $scope.status = {
                inputData: '',
                theDocTypeOptions: [
                    {
                        name: '全部类型',
                        value: '-1'
                    },
                    {
                        name: '新闻',
                        value: '0'
                    },
                    {
                        name: '视频',
                        value: '2'
                    },
                    {
                        name: '图集',
                        value: '3'
                    }
                ],
                theDocType: {
                    name: '全部类型',
                    value: '-1'
                }
            };
            $scope.data = {
                listData: [],
                keywords: '' //检索的关键词
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 12,
                PAGECOUNT: 1,
                ITEMCOUNT: 0
            };
            $scope.params = {
                articleUseStatus: '',
                articleCostStatus: '',
                startTime: '',
                endTime: '',
                searchWord: '',
                searchTime: '',
                currPage: '',
                pageSize: $scope.page.PAGESIZE
            };
            initDropDownList();
        }

        function initData() {
            $scope.requestData = requestData;
            requestData();
            getTheFirstTypes();
        }
        /**
         * [initDropDownList description] 初始化下拉菜单
         * @return {[type]} [description]
         */
        function initDropDownList() {
            $scope.status.typeOptions = [
                {
                    name: '稿件状态',
                    value: ''
                },
                {
                    name: '已发布',
                    value: 1
                },
                {
                    name: '未发布',
                    value: 0
                }
            ];
            $scope.status.selectedTypeOption = angular.copy($scope.status.typeOptions[0]);
            $scope.status.statusOptions = [
                {
                    name: '稿费状态',
                    value: ''
                },
                {
                    name: '已发稿费',
                    value: 1
                },
                {
                    name: '未发稿费',
                    value: 0
                }
            ];
            $scope.status.selectedStatus = angular.copy($scope.status.statusOptions[0]);
            $scope.status.theFirstTypeOptions = [
                {
                    name: '一级分类',
                    value: ''
                }
            ];
            $scope.status.theFirstType = angular.copy($scope.status.theFirstTypeOptions[0]);
            $scope.status.theSecondTypeOptions = [
                {
                    name: '二级分类',
                    value: ''
                }
            ];
            $scope.status.theSecondType = angular.copy($scope.status.theSecondTypeOptions[0]);
        }
        /**
         * [requestData description] 产品列表查询
         * @return {[type]} [description]
         */
        $scope.requestData = function () {
            requestData();
        };
        // 获取一级分类
        function getTheFirstTypes() {
            httpService.http('/mcnww/web/classic/classicList.do', '', 'get').then(function (res) {
                $scope.status.theFirstTypeOptions = $scope.status.theFirstTypeOptions.concat(
                    res.data.map(function (item) {
                        return {
                            name: item.departName,
                            value: item.id
                        };
                    })
                );
                res.data[0] && getTheSecondTypes(res.data[0]);
            });
        }
        // 获取二级分类
        function getTheSecondTypes(item) {
            if (item.id === undefined) return;
            httpService.http('/mcnww/web/classic/classicList.do', { id: item.id }, 'get').then(function (res) {
                $scope.status.theSecondTypeOptions = $scope.status.theSecondTypeOptions.concat(
                    res.sList.map(function (item) {
                        return {
                            name: item.departName,
                            value: item.id
                        };
                    })
                );
                $scope.status.theSecondType = angular.copy($scope.status.theSecondTypeOptions[0]);
            });
        }
        // 一级分类 change 事件
        $scope.firstTypeChange = function () {
            $scope.status.theSecondType = angular.copy($scope.status.theSecondTypeOptions[0]);
            requestData();
            getTheSecondTypes($scope.status.theFirstType);
        };
        /**
         * [requestData description] 初始化列表数据
         */
        function requestData() {
            $scope.params.articleUseStatus = $scope.status.selectedTypeOption.value;
            $scope.params.articleCostStatus = $scope.status.selectedStatus.value;
            $scope.params.firstClassId = $scope.status.theFirstType.value;
            $scope.params.articleType = $scope.status.theDocType.value;
            $scope.params.secondClassId = $scope.status.theSecondType.value;
            $scope.loadingPromise = httpService.http('/mcnww/web/article/articleList.do', $scope.params, 'get').then(function (data) {
                $scope.data.listData = data.data.ldata;

                $scope.page = {
                    CURRPAGE: data.data.startPage,
                    PAGESIZE: data.data.pageSize,
                    ITEMCOUNT: data.data.totalResults,
                    PAGECOUNT: data.data.totalPages
                };
                for (var i = 0; i < $scope.data.listData.length; i++) {
                    $scope.data.listData[i].newTime = $filter('date')($scope.data.listData[i].oprTime, 'yyyy-MM-dd HH:mm:ss').toString();
                }
                /**
                 *  处理数据 发布媒体
                 */
                var dataLength = data.data.ldata;
                // str.replace(/\"/g,"");
                for (var j = 0; j < dataLength.length; j++) {
                    if (dataLength[j].articlePublishDept) {
                        dataLength[j].articlePublishDept = dataLength[j].articlePublishDept
                            .substring(1, dataLength[j].articlePublishDept.length - 1)
                            .replace(/\"/g, '')
                            .split(',')
                            .join(' - ');
                    } else {
                        dataLength[j].articlePublishDept = '-';
                    }
                }
            });
        }
        /**
         * [queryByDropdown description] 筛选条件触发后请求数据
         * @param  {[type]} key   [description] 请求对象参数key
         * @param  {[type]} value [description] 请求对象值
         * @return {[type]}       [description] null
         */
        $scope.queryByDropdown = function () {
            $scope.params.startTime = $scope.status.startDate;
            $scope.params.endTime = $scope.status.endDate;
            requestData();
        };
        /**
         * [fullTextSearch description;全文检索]
         * @param  {[type]} ev [description:按下回车也能提交]
         */
        $scope.fullTextSearch = function (ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.params.searchWord = $scope.data.keywords;
                requestData();
            }
        };
        /**
         * [selectPageNum description]选择分页条数
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function () {
            $scope.params.currPage = $scope.page.CURRPAGE;
            $scope.params.pageSize = $scope.page.PAGESIZE;
            $scope.status.copyCurrPage = 1;
            requestData();
        };
        /**
         * [pageChanged description]分页请求
         * @return {[type]} [description]
         */
        $scope.pageChanged = function () {
            $scope.params.currPage = $scope.page.CURRPAGE;
            // $scope.status.jumpToPageNum = $scope.page.CURRPAGE;
            requestData();
        };
        /**
         * [jumpToPage description:跳转指定页面]
         */
        $scope.jumpToPage = function () {
            jumpToPage();
        };

        function jumpToPage() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.params.currPage = $scope.status.copyCurrPage;
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        }
        /**
         * [dateFormat description] 时间格式化
         * @return {[type]} [description]
         */
        $scope.dateFormat = function (item) {
            item.newTime = $filter('date')(item.postTime, 'yyyy-MM-dd HH:mm:ss').toString();
        };
    }
]);
